import * as React from 'react';
import { Popover } from 'antd';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { FC } from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../../utils/DataAccessUtils';
import {
	DEPARTMENT_DISPLAY,
	MOBILE_PHONE_DISPLAY,
	TITLE_DISPLAY,
	UserCard,
	WORK_PHONE_DISPLAY,
} from './UserCard';
import { ContactAvatar } from '../../contact_avatar/ContactAvatar';

interface UserNameComponentProps {
	contact: any;
	userType?: 'buyer' | 'supplier';
	mode?: 'card' | 'inline' | 'container' | 'avatar' | 'dropdown';
	nameFormat?: string;
	secondaryField?: string;
	showAvatar?: boolean;
	showNameWithAvatar?: boolean;
	size?: 'default' | 'large';
	allowHover?: boolean;
	popoverMode?: 'simple' | 'full';
	placement?: string;
	underline?: boolean;
	details?: any;
	extraDetails?: any;
	renderName?: any;
	onClick?: any;
	account?: any;
	status?: any;
}

export const UserName: FC<UserNameComponentProps> = ({
	contact,
	userType = 'buyer',
	mode = 'card',
	nameFormat = 'nameGiven nameFamily',
	secondaryField = 'email',
	showAvatar = true,
	showNameWithAvatar = false,
	size = 'default',
	allowHover = true,
	popoverMode = 'full',
	placement = 'leftTop',
	underline = true,
	details = [TITLE_DISPLAY, DEPARTMENT_DISPLAY, MOBILE_PHONE_DISPLAY, WORK_PHONE_DISPLAY],
	extraDetails = [],
	renderName,
	status,
	onClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
	},
	account,
}) => {
	const nameList = nameFormat
		.match(/([a-zA-z])\w+/g)
		.map((name) => [name, nullSafeGetOrElse(name, contact, '')]);
	let fullName = nameFormat.slice();
	nameList.forEach(function (item) {
		let myExp = new RegExp(item[0], 'g');
		fullName = fullName.replace(myExp, item[1]);
	});
	const subTitle = nullSafeGet(secondaryField, contact);

	const popoverContent = (
		<UserCard
			status={status}
			userType={userType}
			contact={contact}
			name={fullName}
			subTitle={subTitle}
			showAvatar={showAvatar}
			size={size}
			mode={popoverMode}
			details={details}
			extraDetails={extraDetails}
			onClick={onClick}
			account={account}
		/>
	);
	const element = renderName ? (
		renderName(contact)
	) : mode === 'card' ? (
		<span className={`cursor-pointer ${underline ? 'underline' : ''}`}>
			<UserCard
				status={status}
				userType={userType}
				contact={contact}
				name={fullName}
				subTitle={subTitle}
				showAvatar={showAvatar}
				size={size}
				details={details}
				extraDetails={extraDetails}
				onClick={onClick}
				account={account}
			/>
		</span>
	) : mode === 'inline' ? (
		<span className={`cursor-pointer ${underline ? 'underline' : ''}`}>
			{showNameWithAvatar ? (
				<span className="mr-2">
					<ContactAvatar hidePopover size={20} contact={contact} />
				</span>
			) : null}
			{fullName}
		</span>
	) : mode === 'container' ? (
		<>
			{showNameWithAvatar ? (
				<span className="mr-2">
					<ContactAvatar hidePopover size={20} contact={contact} />
				</span>
			) : null}
			<Ellipsis tooltip={false} fullWidthRecognition={true}>
				{fullName}
			</Ellipsis>
		</>
	) : mode === 'avatar' ? (
		<span className={`cursor-pointer ${underline ? 'underline' : ''}`}>
			<UserCard
				status={status}
				userType={userType}
				contact={contact}
				name={fullName}
				subTitle={subTitle}
				showAvatar={showAvatar}
				size={size}
				mode={mode}
				details={details}
				extraDetails={extraDetails}
				onClick={onClick}
			/>
		</span>
	) : mode === 'dropdown' ? (
		<UserCard
			status={status}
			userType={userType}
			contact={contact}
			name={fullName}
			subTitle={subTitle}
			showAvatar={false}
			size={size}
			mode="simple"
			details={[]}
			extraDetails={[]}
			onClick={undefined}
			account={account}
		/>
	) : (
		<span></span>
	);

	return allowHover ? (
		<Popover placement={placement} content={popoverContent} style={{ zIndex: 1000 }}>
			{element}
		</Popover>
	) : (
		element
	);
};
